"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchingUtility = void 0;
exports.batchingUtility = {
    /**
     *
     * @param asyncTasks : Array[key, function] .
     * @param chopSize : Exact size of batch .
     */
    chopAsyncTasks: function (asyncTasksEntries, chopSize) {
        const choppedTasksList = [];
        while (asyncTasksEntries.length > 0) {
            choppedTasksList.push(asyncTasksEntries.splice(0, chopSize));
        }
        return choppedTasksList;
    },
    /**
     *
     * @param asyncTasks : Array / Object of Promises
     * @param chopSize : Exact size of batch, default to 50
     * @param rejectOnFailure : Boolean value of handling failures .
     * @param callback
     */
    batchAsyncCalls: function (asyncTasks, chopSize = 50, rejectOnFailure = false, callback) {
        const objectEntries = Object.entries(asyncTasks);
        const choppedAsyncTaskList = this.chopAsyncTasks(objectEntries, chopSize);
        return new Promise((resolve, reject) => {
            const finalResult = choppedAsyncTaskList.reduce((acc, items) => {
                return acc.then((data) => {
                    return new Promise((resolve, reject) => {
                        const iterableItems = items.filter((item) => item !== undefined);
                        const dataSet = [];
                        iterableItems.forEach(([key, promiseMethod]) => {
                            promiseMethod()
                                .then((result) => {
                                dataSet.push([key, result]);
                            })
                                .catch((error) => {
                                if (rejectOnFailure) {
                                    reject(error);
                                }
                                else {
                                    dataSet.push([key, error]);
                                }
                            })
                                .finally(() => {
                                if (dataSet.length === iterableItems.length) {
                                    resolve(data.concat(dataSet));
                                }
                            });
                        });
                    }).catch((error) => {
                        reject(error);
                    });
                });
            }, Promise.resolve([]));
            finalResult
                .then((result) => {
                const finalResolve = Array.isArray(asyncTasks) ? [] : {};
                result.forEach(([key, value]) => (finalResolve[key] = value));
                if (callback) {
                    callback(finalResolve);
                    return;
                }
                resolve(finalResolve);
            })
                .catch((error) => {
                if (callback) {
                    callback(error);
                    return;
                }
                reject(error);
            });
        });
    },
};
